import { MoveButtonsStyled } from '@OnArk/styles/OrderedList.styled';

import React, { ReactElement } from 'react';

import Icon from '@OnArk/SVGs/Icon';

import { useOrderableContext } from './context';

export const MoveButton = ({ idx }: { idx: number }): ReactElement => {
  const { items, onItemMove } = useOrderableContext();

  return (
    <MoveButtonsStyled>
      <button
        css={{ display: idx === 0 ? 'none' : 'block' }}
        type="button"
        onClick={e => {
          e.stopPropagation();
          if (onItemMove) onItemMove(idx, idx - 1);
        }}
      >
        <Icon
          name="ARROWS_Up"
          position="top"
          right="0"
          size="15"
          tooltip="Up"
        />
      </button>
      <button
        css={{ display: idx === items.length - 1 ? 'none' : 'block' }}
        type="button"
        onClick={e => {
          e.stopPropagation();
          if (onItemMove) onItemMove(idx, idx + 1);
        }}
      >
        <Icon
          name="ARROWS_Down"
          position="bottom"
          right="0"
          size="15"
          tooltip="Down"
        />
      </button>
    </MoveButtonsStyled>
  );
};
